module.exports = __webpack_public_path__ + "img/reject.7fc68227.svg";